// ???: Because we have custom Durandal transitions, we need to add this module directly in the app
/* eslint-disable */
/**
 * Durandal 2.1.0 Copyright (c) 2012 Blue Spire Consulting, Inc. All Rights Reserved.
 * Available via the MIT license.
 * see: http://durandaljs.com or https://github.com/BlueSpire/Durandal for details.
 */
/**
 * The entrance transition module.
 * @module entrance
 * @requires system
 * @requires composition
 * @requires jquery
 */
define(['durandal/system', 'durandal/composition', 'jquery'], function (system, composition, $) {
  // no animation
  var entrance = function (context) {
    return system
      .defer(function (dfd) {
        if (!context.keepScrollPosition) {
          $(document).scrollTop(0);
        }
        dfd.resolve();
      })
      .promise();
  };

  return entrance;
});
